import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrawBaseHeightDirective } from './draw-base-height.shared.directive';
import { DrawCollapseSharedDirective } from './draw-collapse.shared.directive';
import { DrawOffsetSharedDirective } from './draw-offset.shared.directive';
import { DrawOffsetMobileSharedDirective } from './draw-offset-mobile.shared.directive';
import { DrawFollowSharedDirective } from './draw-follow.shared.directive';
import { DrawMinHeightSharedDirective } from './draw-min-height.shared.directive';
import { DrawOpacitySharedDirective } from './draw-opacity.shared.directive';
import { DrawContentMarginSharedDirective } from './draw-content-margin.shared.directive';

import { DrawCollapseResolver } from './draw-collapse.shared.resolver';
import { DrawExpandResolver } from './draw-expand.shared.resolver';

const toExport: any[] = [
    DrawBaseHeightDirective,
    DrawCollapseSharedDirective,
    DrawOffsetSharedDirective,
    DrawOffsetMobileSharedDirective,
    DrawFollowSharedDirective,
    DrawMinHeightSharedDirective,
    DrawOpacitySharedDirective,
    DrawContentMarginSharedDirective,
];

@NgModule({
    declarations: [
        ...toExport,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        ...toExport,
    ],
    providers: [
        DrawExpandResolver,
        DrawCollapseResolver,
    ],
})
export class DrawCollapseDirectiveSharedModule { }
